import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FaHome, FaUser, FaEnvelope, FaShoppingBag } from "react-icons/fa";
import { Badge, Button, Tooltip } from "@mui/material";
import "./HomeTab.scss";
import { CiKeyboard } from "react-icons/ci";
import { MdOutlineQrCodeScanner } from "react-icons/md";
import { useRecoilState } from "recoil";
import { scannerActive } from "../Recoil/atom";

const HomeTab = () => {
  const [activeTab, setActiveTab] = useState("/");
  const [activeForScanner, setActiveForScanner] = useRecoilState(scannerActive);
  const location = useLocation();

  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div>
      {location.pathname == "/TvConnect" ? (
        <div style={styles.container} className="Home_tabMain">
          <NavLink
            style={styles.tab}
            activeClassName="active"
            onClick={() => setActiveForScanner("scanner")}
          >
            <Button
              style={{
                display: "flex",
                flexDirection: "column",
                color: "rgb(102, 102, 102)",
              }}
            >
              <MdOutlineQrCodeScanner
                style={
                  activeForScanner === "scanner"
                    ? styles.activeIcon
                    : styles.icon
                }
              />
              <span
                style={
                  activeForScanner === "scanner" ? styles.activeText : styles.text
                }
              >
                Scanner
              </span>
            </Button>
          </NavLink>
          <NavLink
            style={styles.tab}
            activeClassName="active"
            onClick={() => setActiveForScanner("manual")}
          >
            <Button
              style={{
                display: "flex",
                flexDirection: "column",
                color: "rgb(102, 102, 102)",
              }}
            >
              <CiKeyboard
                style={
                  activeForScanner === "manual"
                    ? styles.activeIcon
                    : styles.icon
                }
              />
              <span
                style={
                  activeForScanner === "manual"
                    ? styles.activeText
                    : styles.text
                }
              >
                Manual
              </span>
            </Button>
          </NavLink>
        </div>
      ) : (
        <div style={styles.container} className="Home_tabMain">
          <NavLink
            to="/"
            style={styles.tab}
            activeClassName="active"
            onClick={() => handleTabChange("/")}
          >
            <Button
              style={{
                display: "flex",
                flexDirection: "column",
                color: "rgb(102, 102, 102)",
              }}
            >
              <FaHome
                style={activeTab === "/" ? styles.activeIcon : styles.icon}
              />
              <span style={activeTab === "/" ? styles.activeText : styles.text}>
                Home
              </span>
            </Button>
          </NavLink>
          <NavLink
            to="/profile"
            style={styles.tab}
            activeClassName="active"
            onClick={() => handleTabChange("/profile")}
          >
            <Button
              style={{
                display: "flex",
                flexDirection: "column",
                color: "rgb(102, 102, 102)",
              }}
            >
              <FaUser
                style={
                  activeTab === "/profile" ? styles.activeIcon : styles.icon
                }
              />
              <span
                style={
                  activeTab === "/profile" ? styles.activeText : styles.text
                }
              >
                Profile
              </span>
            </Button>
          </NavLink>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    position: "fixed",
    bottom: 0,
    width: "100%",
    backgroundColor: "white",
    height: "60px",
    borderTop: "1px solid #ccc",
    zIndex: 111111111111111,
  },
  tab: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    flex: 1,
    color: "#666",
  },
  icon: {
    marginBottom: "5px",
    fontSize: "20px",
  },
  activeIcon: {
    color: "#7367f0",
    fontSize: "20px",
  },
  text: {
    fontSize: "12px",
  },
  activeText: {
    color: "#7367f0",
    fontSize: "12px",
    marginBottom: "-5px",
    paddingBlock: "5px",
  },
};

export default HomeTab;
